module.exports = __webpack_public_path__ + "img/es-variant.3c388781.svg";